import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
import { LightboxDefaultProps } from "../../types.js";
import { useContainerRect } from "../hooks/index.js";
import { createModule } from "../config.js";
import { clsx, cssClass, cssVar } from "../utils.js";
import { ImageSlide } from "../components/index.js";
import { useController } from "./Controller.js";

var CarouselSlide = function CarouselSlide(_ref) {
  var slide = _ref.slide,
      offset = _ref.offset;

  var _useContainerRect = useContainerRect(),
      setContainerRef = _useContainerRect.setContainerRef,
      containerRect = _useContainerRect.containerRect;

  var _useController = useController(),
      latestProps = _useController.latestProps;

  var render = latestProps.current.render;

  var renderSlide = function renderSlide(rect) {
    var _a, _b, _c, _d;

    var rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, slide, offset, rect);

    if (!rendered && "src" in slide) {
      rendered = React.createElement(ImageSlide, {
        slide: slide,
        offset: offset,
        render: render,
        rect: rect,
        imageFit: latestProps.current.carousel.imageFit
      });
    }

    return rendered ? React.createElement(React.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, slide), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : function (_, x) {
      return x;
    })(slide, rendered), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, slide)) : null;
  };

  return React.createElement("div", {
    ref: setContainerRef,
    className: clsx(cssClass("slide"), cssClass("flex_center")),
    style: _defineProperty({}, cssVar("slide_offset"), offset)
  }, containerRect && renderSlide(containerRect));
};

export var Carousel = function Carousel(_ref2) {
  var slides = _ref2.slides,
      _ref2$carousel = _ref2.carousel,
      finite = _ref2$carousel.finite,
      preload = _ref2$carousel.preload,
      padding = _ref2$carousel.padding,
      spacing = _ref2$carousel.spacing;

  var _useController2 = useController(),
      currentIndex = _useController2.currentIndex,
      globalIndex = _useController2.globalIndex;

  var items = [];

  if ((slides === null || slides === void 0 ? void 0 : slides.length) > 0) {
    for (var i = currentIndex - preload; i < currentIndex; i += 1) {
      if (!finite || i >= 0) {
        items.push(React.createElement(CarouselSlide, {
          key: globalIndex + i - currentIndex,
          slide: slides[(i + preload * slides.length) % slides.length],
          offset: i - currentIndex
        }));
      }
    }

    items.push(React.createElement(CarouselSlide, {
      key: globalIndex,
      slide: slides[currentIndex],
      offset: 0
    }));

    for (var _i = currentIndex + 1; _i <= currentIndex + preload; _i += 1) {
      if (!finite || _i <= slides.length - 1) {
        items.push(React.createElement(CarouselSlide, {
          key: globalIndex + _i - currentIndex,
          slide: slides[_i % slides.length],
          offset: _i - currentIndex
        }));
      }
    }
  }

  var sanitize = function sanitize(value) {
    return value === 0 || value.trim() === "" || value.trim() === "0" ? "0px" : value;
  };

  return React.createElement("div", {
    className: cssClass("carousel"),
    style: _objectSpread(_objectSpread({}, padding !== LightboxDefaultProps.carousel.padding ? _defineProperty({}, cssVar("carousel_padding"), sanitize(padding)) : null), spacing !== LightboxDefaultProps.carousel.spacing ? _defineProperty({}, cssVar("carousel_spacing"), sanitize(spacing)) : null)
  }, items);
};
export var CarouselModule = createModule("carousel", Carousel);